import { render, staticRenderFns } from "./ScmsCityTab.vue?vue&type=template&id=8808d15a&scoped=true&"
import script from "./ScmsCityTab.vue?vue&type=script&lang=js&"
export * from "./ScmsCityTab.vue?vue&type=script&lang=js&"
import style0 from "./ScmsCityTab.vue?vue&type=style&index=0&id=8808d15a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8808d15a",
  null
  
)

export default component.exports